import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ShowMaintenance } from './show-maintenance/show-maintenance.component';
import { ShowUpdateComponent } from './show-update/show-update.component';

@NgModule({
    declarations: [ShowMaintenance, ShowUpdateComponent],
    imports: [IonicModule, CommonModule],
    exports: [IonicModule, ShowMaintenance],
})
export class MaintenanceModule {}
